import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Skeleton } from "antd";
import { GiSofa } from "react-icons/gi";

const Carousal = ({ SubCategoryBanners, SwiperClassName, SkeletonLoad }) => {
  const skeletonArray = Array.from({ length: 1 }, (_, index) => index);
  return (
    <div className="flex w-full">
      <div className="h-[42vh] min-h-[240px] max-h-[420px] w-full">
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          modules={[Pagination]}
          className="mySwiper h-full w-full"
        >
          {SkeletonLoad ? (
            <div className="mt-5">
              {skeletonArray.map((index) => (
                <div key={index}>
                  <Skeleton.Node
                    active={true}
                    style={{ height: "100%", width: "100%" }}
                  >
                    <GiSofa style={{ fontSize: 300, color: "#bfbfbf" }} />
                  </Skeleton.Node>
                </div>
              ))}
            </div>
          ) : (
            SubCategoryBanners.map((el, i) => {
              if (el.device === "2") {
                return (
                  <SwiperSlide key={i} className="h-full w-full">
                    <img
                      src={process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.path}
                      alt="Fina Interiors category banner"
                      className="h-full w-full object-cover"
                    />
                  </SwiperSlide>
                );
              } else {
                return null;
              }
            })
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default Carousal;
